/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import clsx from 'clsx';
import { Tooltip as MuiTooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CustomHelpIcon from './CustomHelpIcon';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: '0.375rem',
    position: 'relative',
    zIndex: 1,
    '&.body-row-tooltip': {
      marginLeft: 0,
    },
    '& .MuiButton-containedPrimary': {
      marginLeft: '0.375rem',
    },
    cursor: 'pointer',
    color: theme.palette?.tooltipBackground,
    '&:hover': {
      color: theme.palette?.tooltipBackground,
    },
  },
  defaultTooltipIcon: {
    '&:focus-visible': {
      boxShadow: `0 0 0 3px ${theme.palette?.focus}`,
      outline: 'none',
      borderRadius: '50%',
    },
  },
  content: {
    fontSize: '1rem',
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
  wide: {
    maxWidth: 'none',
  },
  noWide: {
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  noSpacing: {
    padding: 0,
    margin: 0,
  },
}));

export default function Tooltip(props) {
  const { title, hideAria, customAria, children, wide, customWide, className, noSpacing, ...otherProps } = props;
  const classes = useStyles();
  const defaultChildComponent = <CustomHelpIcon />;
  const aria = customAria || title;
  return (
    <MuiTooltip
      {...otherProps}
      aria-label={!hideAria && typeof aria === 'string' ? aria : undefined}
      tabIndex="0"
      title={(
        <Typography component="div" variant="body1">
          {title}
        </Typography>
      )}
      className={clsx(classes.root, className, !children && classes.defaultTooltipIcon, noSpacing && classes.noSpacing)}
      classes={{
        tooltip: customWide || clsx({ [classes.wide]: wide, [classes.content]: true, [classes.noWide]: !wide }),
      }}
      arrow
    >
      {children || defaultChildComponent}
    </MuiTooltip>
  );
}
